import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-external',
  templateUrl: './external.component.html',
  styleUrls: ['./external.component.css']
})
export class ExternalComponent implements OnInit {
  searchObject = this.routeLocation.snapshot.queryParams;
   external = {
   	url: this.sanitizer.bypassSecurityTrustResourceUrl(decodeURI(this.searchObject.url)),
    height:$("body").height()-72
  };
  constructor(private sanitizer: DomSanitizer,
    private routeLocation: ActivatedRoute) { }

  
 

  ngOnInit() {
  }

}
